export default __webpack_public_path__ + "static/media/template15.8c8c29b9.svg";